<template>
  <div class="GdPage">
    <div class="back" @click="goBack()">
      <div class="backIcon">
        <img src="../../assets/images/workOrderReview/back.png" alt="">
      </div>
      <div class="backText">{{$t('lang.UploadProof.DetailedInformation')}}</div>
    </div>
      <div class="listView">
        <div class="title">Processing Review Notice</div>
        <div class="dearSir">Dear Sir,</div>
        <div class="content">We regret to inform you that we are unable to process your application due to insufficient submitted materials.</div>
        <div class="tag1">Best regards,</div>
        <div class="tag2">PGEbet Team</div>
        <div class="time"></div>
      </div>
  </div>
</template>

<script>
import {Loadmore} from 'mint-ui'
// import request from '@/service'
import showMore from '@/assets/images/common/showMore.gif'
export default {
  name: 'UploadproofDepositDetail',
  components: {
    Loadmore
  },
  data () {
    return {
      Skip: 0,
      Take: 1,
      check: 0,
      list: [],
      hasLoadAll: true,
      firstLoad: true,
      showMore
    }
  },
  watch: {
    '$store.state.locale': function () {

    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getList () {
      // let url = 'innovation/unread/ticket/list'
      // let data = {
      //   Skip: this.Skip,
      //   Take: this.Take,
      //   UserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      // }
      // request('post', url, data, false).then(res => {
      //   if (res) {
      //     console.log(res)
      //   }
      // }).catch(err => {
      //   console.log(err)
      // })
    }
  }
}
</script>

<style lang="less" scoped>
/* 通用样式 */
input::placeholder {
  color: #464646;
  opacity: 1; /* 可选：设置placeholder文本的不透明度 */
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-input-placeholder {
  color: #464646;
}
.GdPage {
  position: relative;
  top: -10px;
  height: 100vh;
  overflow-y: hidden;
  .back{
    height: 6.11vw;
    display: flex;
    align-items: center;
    margin-top: 22vw;

    .backIcon{
      margin-left: 5vw;

    }
    .backText{
      margin-left: 5vw;
      color: #F6D9AA;
      font-weight: 700;
      font-size: 5.27vw;
    }
  }

  .listView{
    margin-top: 6vw;
    border: 1px solid red;
    height: 83vh;
    //display: flex;
    //flex-direction: column;
    //align-items: center;
    overflow-y: hidden;
    font-size: 3.611vw;
    color: #D6D6D6;
    .title{
      color: #F6D9AA;
      font-size: 6.11vw;
      font-weight: 700;
    }
    .dearSir{}
    .content{
      width: 82.497vw;
    }
    .tag1{}
    .tag2{}
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/workOrderReview/proofResultPage.vue